

import React from 'react'
import Button from 'shared/components/Button'
import DataTable from 'shared/components/DataTable'

const table = [
  {
    label: 'Name',
    data: (d) => {
      return d.user?.first_name + ' ' + d.user?.last_name
    },
  },
  {
    label: 'Role',
    data: (d) => {
      return <span className="capitalize">{d.user?.user_role}</span>
    },
  },
  {
    label: 'Title',
    data: (d) => {
      return d.title || '-'
    },
  },
  {
    label: 'Email',
    data: (d) => {
      return d.user?.email
    },
  },
  {
    label: 'Telephone',
    data: (d) => {
      return d.user?.phone_number || '-'
    },
  },
  {
    label: 'Is Default',
    data: (d) => {
      return d.is_default_agent ? 'Yes' : 'No'
    },
  },
]

function ManagePropertyStaffSection({ property }) {
  return (
    <>
      <div className="flex justify-between items-center mt-[16px]">
        <div className="text-xl">Staff</div>
        <div className="">
          <Button size="small" rounded variant="secondary">
            Add staff
          </Button>
        </div>
      </div>
      <DataTable data={property.agents} structure={table} emptyLabel="No staff members added yet" />
    </>
  )
}

export default ManagePropertyStaffSection
